<template>
    <div class="form-group question">
        <label class="question-label">{{ currentQuestion.label }}</label>
        <div v-if="currentQuestion.image" class="question-image">
            <img :src="currentCdn + '/img/' + currentQuestion.image"/>
        </div>
        <response v-for="reponse in currentQuestion.reponses"
                  :key="reponse.id"
                  :question="currentQuestion"
                  :response="reponse"
                  @input="updateValue($event)">
        </response>
        <div v-if="currentQuestion.info" v-html="currentQuestion.info">
        </div>
    </div>
</template>
<script>
    import Response from './Response.vue';

    export default {
        props: [
            'question',
            'cdn',
            'value'
        ],
        
        // REACTIVE PROPERTIES
        data() {
            return {
                currentResponse: null
            }
        },
        computed: {
            currentQuestion() {
                return this.question;
            },
            currentCdn() {
                return this.cdn;
            }
        },
        watch: {
            value(val) {
                this.currentResponse = val;
            }
        },

        // METHODS
        methods: {
            updateValue(val) {
                this.currentResponse = val;
                this.$emit('input', val);
            }
        },

        // LIFECYCLE
        mounted() {
            this.$console.log('debug', 'Question::mounted');
        },

        // COMPONENTS
        components: {
            response: Response
        }
    }
</script>


// WEBPACK FOOTER //
// Question.vue?41687cb0